import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const fieldLabel = "text-xs font-mono uppercase tracking-[0.15em] text-slate-700 font-medium";
const inputCls = "mt-2 rounded-none border-slate-300";

/** Step 4 — who the photographer meets on-site and how to access the property. */
export function DetailsStep({ form }) {
  const { meeting, setMeeting } = form;
  return (
    <div data-testid="step-details" className="space-y-6 fade-up">
      <h2 className="font-display text-3xl tracking-tight">On-site details</h2>
      <p className="text-sm text-slate-500">Who will our photographer be meeting, and how do we access the property?</p>
      <div className="grid sm:grid-cols-2 gap-4">
        <div><Label className={fieldLabel}>Contact name on site</Label><Input data-testid="meeting-name" value={meeting.contact_name} onChange={(e) => setMeeting({ ...meeting, contact_name: e.target.value })} className={inputCls} /></div>
        <div><Label className={fieldLabel}>Contact phone on site</Label><Input data-testid="meeting-phone" value={meeting.contact_phone} onChange={(e) => setMeeting({ ...meeting, contact_phone: e.target.value })} className={inputCls} /></div>
      </div>
      <div><Label className={fieldLabel}>Access instructions</Label><Input data-testid="meeting-access" value={meeting.access} onChange={(e) => setMeeting({ ...meeting, access: e.target.value })} className={inputCls} placeholder="Lockbox code, gate, etc." /></div>
      <div><Label className={fieldLabel}>Anything else we should know?</Label><Textarea data-testid="meeting-notes" value={meeting.notes} onChange={(e) => setMeeting({ ...meeting, notes: e.target.value })} className={inputCls} rows={3} /></div>
    </div>
  );
}
